

















import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import Selector from '@ui/Inputs/Selector'
import sort from  '@utils/sort.coffee'
import TagBar from '@ui/TagBar'

settings =
  name: 'SupplierSelector'

  vue:
    props: ['selectedOptionId', 'theme', 'actions']
    components: { Selector, TagBar }

    data: ->
      supplierOptions: []

    mounted: ->
      @searchSuppliers()

    computed:
      selectorActions: -> { ...@actions, search: @searchSuppliers }
      selectorOptions: -> { searchBoxPlaceholder: 'Search by name' }
      selectedKeys: ->
        return [] unless @selectedOptionId
        [@selectedOptionId]

      tagBarOptions: ->
        {
          bar: {
            theme: 'selector',
            max: 3,
          },
          tag: {
            theme: 'selector',
            maxLength: 8
          },
          initializeExpanded: false,
        }

    methods:
      searchSuppliers: (value = '') ->
        text = value.trim()
        @supplierOptions = []
        suppliers = await RecessAPI.search 'suppliers', { text, per_page: 100 }

        options = []
        for supplier in suppliers
          options.push({
            key: supplier.id,
            value: supplier.name,
            type: 'supplier_list',
            sortBy: "#{supplier.id} #{supplier.name}}",
            data: supplier
          })
        @supplierOptions = options.sort((a, b) -> "#{a.value}".localeCompare("#{b.value}"))

export default VueOptions.vue settings
